import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { SkillTypes } from '../../../services/skill';
import { TaskRewardProps } from '../../../services/task';
import Icon from '../../../ui/Icon';
import Resize from '../../../ui/Resize';
import Separator, { SeparatorColor, SeparatorSize } from '../../../ui/Separator';
import { colorShade } from '../../../utils/style';
import TaskEditReward from './TaskEditReward';

interface Props {
    rewards: TaskRewardProps[];
    onChange: (rewards: TaskRewardProps[]) => void;

    className?: string;
}

export default function TaskEditRewards({ rewards, onChange, className }: Props) {
    const [rawRewards, setRawRewards] = useState<TaskRewardProps[]>(rewards);

    useEffect(() => { setRawRewards(rewards) }, [rewards]);
    useEffect(() => { rawRewards && onChange(rawRewards) }, [rawRewards, onChange]);

    function onChangeInternal(newReward: TaskRewardProps, index: number) {
        const rewardsCopy = [...(rawRewards || [])];
        rewardsCopy[index] = newReward;
        setRawRewards(rewardsCopy);
    }

    function addReward() {
        const rewardsCopy = [...(rawRewards || [])];
        rewardsCopy.push({ xp: 0.5, type: SkillTypes.HEALTH });
        setRawRewards(rewardsCopy);
    }

    function remove(index: number) {
        const rewardsCopy = [...(rawRewards || [])];
        rewardsCopy.splice(index, 1);
        setRawRewards(rewardsCopy);
    }

    return (
        <Wrapper className={className}>
            <div className='task-edit-rewards-title'>Reward</div>
            <Resize>
                <div className='task-edit-rewards'>
                    {(rawRewards || []).map((reward, index) =>
                        <TaskEditReward key={index} reward={reward} onChange={(newReward) => onChangeInternal(newReward, index)} onRemove={() => remove(index)}></TaskEditReward>
                    )}
                    <div className='task-edit-rewards-add' onClick={addReward}>
                        <Icon icon='add-3' size={24}></Icon>
                    </div>
                </div>
            </Resize>

            <Separator size={SeparatorSize.LARGE} spacing={10} color={SeparatorColor.SECONDARY} offset='45%'></Separator>

        </Wrapper >
    )
}

const Wrapper = styled.div`


    /* background-color: #00000044; */
    /* background-color: ${props => props.theme.backgroundColor}; */
    /* background-color: ${props => colorShade(props.theme.backgroundColor, 0.05)}; */
    /* padding: 10px; */
    border-radius: ${props => props.theme.borderRadius};

    .task-edit-rewards-title {
        font-size: 12px;
        opacity: 0.5;
        padding: 0 10px;
        margin-bottom: 14px;
        text-align: center;
    }

    .task-edit-rewards {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        gap: 10px;
        /* min-height: 110px; */
        padding-bottom: 10px;
    }

    .task-edit-rewards-add {
        background-color: ${props => props.theme.backgroundColor};
        border-radius: ${props => props.theme.borderRadius};
        padding: 16px;
        cursor: pointer;
    }
`